import { render, staticRenderFns } from "./CampaignFeedbackModal.vue?vue&type=template&id=40ed1b4f&scoped=true&"
import script from "./CampaignFeedbackModal.vue?vue&type=script&lang=ts&"
export * from "./CampaignFeedbackModal.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignFeedbackModal.vue?vue&type=style&index=0&id=40ed1b4f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed1b4f",
  null
  
)

export default component.exports